<div class="container-fluid">
    <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>
    <ul class="breadcrumb">
        <li><strong>Onde estou:</strong></li>
        <li class="active">
            <span>Acordos/Consulta/<b> Aprovar Acordo</b></span>
        </li>
    </ul>
    <!-- {{ filtroAcordosForm.value | json }} -->

    <form [formGroup]="filtroAcordosForm">
    <mat-accordion class="box-sombra" id="topo">
        <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Filtrar Acordos
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-grid-list cols="5" rowHeight="100px">
                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Data da Proposta Inicio/fim</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="00/00/0000" formControlName="datPropostaInicialDate">
                            <input matEndDate placeholder="00/00/0000" formControlName="datPropostaFinalDate">
                        </mat-date-range-input>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Data da Vigência Inicio/fim</mat-label>
                        <mat-date-range-input [rangePicker]="picker2">
                            <input matStartDate placeholder="00/00/0000" formControlName="datVigenciaInicialDate">
                            <input matEndDate placeholder="00/00/0000" formControlName="datVigenciaFinalDate">

                        </mat-date-range-input>

                        <mat-icon *ngIf="filtroAcordosForm.get('datVigenciaInicialDate')?.value || filtroAcordosForm.get('datVigenciaFinalDate')?.value"
                            (click)="limparDatas()" aria-hidden="false" aria-label="Limpe o resultado da pesquisa de Frota"
                            matIconSuffix>delete</mat-icon>
                        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker2></mat-date-range-picker>
                    </mat-form-field>
                </mat-grid-tile>



                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Código do Acordo</mat-label>
                        <input matInput placeholder="Ex. 123456" autocomplete="off" formControlName="codAcordo">
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Código AEP</mat-label>
                        <input type="number" matInput placeholder="Ex. 123456" autocomplete="off" formControlName="codAep">
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Código ADC</mat-label>
                        <input type="number"  matInput placeholder="Ex. 123456" autocomplete="off" formControlName="codAdc">
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Filtrar Frota</mat-label>
                        <!-- Se filtroacordos.nomeFrota tem valor e diferente de ''  adicionar erro no i-->
                        <input matInput placeholder="Ex. Ctf frota #" autocomplete="off"

                            formControlName="nomeFrota">

                        <mat-icon (click)="openDialog()" matIconSuffix>search</mat-icon>
                        <mat-icon (click)="limpaFiltro()" aria-hidden="false"
                            aria-label="Limpe o resultado da pesquisa de Frota" matIconSuffix>delete</mat-icon>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Situação</mat-label>
                        <mat-select formControlName="statusAcordo">
                            <mat-option selected="selected">Selecione</mat-option>
                            <mat-option *ngFor="let status of statusAcordos" [value]="status.codStatus">
                                {{ status.dscStatus }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                    <mat-form-field >
                        <mat-label>Combustível</mat-label>
                        <mat-select formControlName="indCombustivel">
                            <mat-option selected="selected">Selecione</mat-option>
                            <mat-option *ngFor="let combustivel of combustiveis" [value]="combustivel.descricaoCombustivel">
                                {{ combustivel.combustivel| uppercase }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile colspan="1" rowspan="1">
                        <button
                            class="btn-filtrar"

                            mat-flat-button type="button" (click)="getAcordos()">
                            <span>Consultar </span>
                            <mat-icon>search</mat-icon>
                        </button>
                </mat-grid-tile>


            </mat-grid-list>


        </mat-expansion-panel>
    </mat-accordion>
    </form>


    <div class="row" style="margin-top: 10px;">
        <div class="col text-end">
            <button mat-flat-button type="button" class="btn-novo-acordo" (click)="abrirNovoAcordo()">
                Novo acordo
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>

    <div class="row" *ngIf="selection.selected.length">
        <div class="col total-selecionado">
            <mat-icon>info</mat-icon>
            <span>{{selection.selected.length}}</span>
            acordo{{selection.selected.length == 1 ? '' : 's' }} selecionado{{selection.selected.length == 1 ? '' :
            's' }}
        </div>
    </div>
    <div class="row" style="margin-bottom: 10px">
        <div class="col">
            <button mat-flat-button type="button" class="btn-acoes" (click)="dialogAceitarAcordo()"
                [ngClass]="{'btn-ativo': selection.selected.length}" [disabled]="!selection.selected.length"
                style="margin-left: 0;">
                <mat-icon>check</mat-icon>
                <span> Aprovar</span>
            </button>
            <button mat-flat-button type="button" class="btn-acoes" (click)="dialogRecusarAcordo()"
                [ngClass]="{'btn-ativo': selection.selected.length}" [disabled]="!selection.selected.length">
                <mat-icon>cancel</mat-icon>
                <span> Recusar</span>
            </button>
            <button mat-flat-button type="button" class="btn-acoes" (click)="dialogCancelarAcordo()"
                [ngClass]="{'btn-ativo': selection.selected.length}" [disabled]="!selection.selected.length">
                <mat-icon>block</mat-icon>
                <span> Cancelar</span>
            </button>
            <button mat-flat-button type="button" class="btn-acoes" (click)="dialogEditarAcordo()"
                [ngClass]="{'btn-ativo': selection.selected.length}" [disabled]="!selection.selected.length">
                <mat-icon>edit</mat-icon>
                <span> Editar</span>
            </button>

            <button mat-flat-button type="button" class="btn-export-excel" (click)="exportToExel()">
                <span> Exportar Excel</span>
                <mat-icon>description</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-container box-sombra">
        <mat-table #table [dataSource]="dataSource" matSort #sort="matSort">
            <ng-container matColumnDef="selected">

                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()" matTooltip="Selecionar todos"
                        matTooltipPosition="above">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="codAcordo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Acordo</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.codAcordo}} </mat-cell>
            </ng-container>


            <ng-container matColumnDef="codAep">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Cód. Aep</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.codAep}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="datProposta">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Data da Proposta</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.datProposta | date: "dd/MM/yyyy"}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="datInicioVigencia">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Data Inico Vigencia</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.datInicioVigencia | date: "dd/MM/yyyy"}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="datFimVigencia">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Data Fim Vigencia</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.datFimVigencia | date: "dd/MM/yyyy"}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dscTipoAcordoPreco">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Tipo Acordo</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.dscTipoAcordoPreco | titlecase}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="codFrota">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Cód. Frota</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.codFrota}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="razaoSocialFrota">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Frota</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.razaoSocialFrota | titlecase}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tipoCombustivel">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Combustível</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.tipoCombustivel | titlecase}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vlrPrecoTela">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Preço Bomba</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.vlrPrecoTela |currency}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vlrDescontoFixoAcordo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Desconto</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.vlrDescontoFixoAcordo |currency}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="vlrPrecoAcordo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Preço Acordo</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.vlrPrecoAcordo |currency}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="codAdc">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Cód. ADC</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.codAdc}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dscPeriodo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Período</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.dscPeriodo | titlecase}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="numPrazo">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Prazo</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.numPrazo}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="vlrMdr">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Taxa Acordo</mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{ element.vlrMdr ? ((element.vlrMdr / 100) | percent:'1.2-2') : ''}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="situacao">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Situação</mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.situacao | titlecase}} </mat-cell>
            </ng-container>
      


            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

        <tr *ngIf="dataSource.data.length === 0 && !loading" class="no-data">
            <td colspan="3" style="text-align: center;">
                Nenhum acordo encontrado!
            </td>
        </tr>

        <tr *ngIf="loading" class="no-data">
            <td colspan="3" style="text-align: center;">
                Aguarde, consultando acordos...
            </td>
        </tr>

        <div class="paginator-centre">
            <mat-paginator [pageSizeOptions]="[20, 50, 500]" showFirstLastButtons
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </div>
    <div class="row" style="margin: 30px 0 15px 0">
        <div class="col text-end">
            <button mat-flat-button (click)="scrollToTopAnimated()" matTooltip="Ir para o topo da página"
                matTooltipPosition="above" aria-label="Ir para o topo da página" aria-hidden="false" type="button"
                class="btn-consulta">
                Ir para o topo
                <mat-icon>vertical_align_top</mat-icon>
            </button>
        </div>
    </div>

</div>